// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"884":"b1322e81","897":"cc6b4a8b"}[chunkId] + ".js";
};